import React from 'react'
import Back from '../../common/Back'
import i from '../images/postpic2.jpg'
import './contact.css'

const Contact = () => {
    return (
        <>
            <section className="contact mb">
                <Back name='Contact Us' title='Get Helps & Friendly Support' cover={i} />
                <div className="container ">
                    <form action="" className="shadow">
                        <h4>Fillup The Form</h4>
                        <div className='input'>
                            <input type="text" placeholder='Name' id='' name='' />
                            <input type="text" placeholder='Email' id='' name='' />
                        </div>
                        <input type="text" placeholder='Subject' />
                        <textarea name="" id="" cols="30" rows="10"></textarea>
                        <button>Submit Request</button>
                    </form>

                </div>
            </section>
        </>
    )
}

export default Contact
